import axios from 'axios';
import runtimeEnv from '@mars/heroku-js-runtime-env';

import { get, clear } from './localStorage';
import history from './history';

const env = runtimeEnv();

const baseURL = env.REACT_APP_API_URL;
const instance = axios.create({ baseURL });

instance.interceptors.request.use((config) => {
  const configuration = config;
  const credentials = get('credentials');
  configuration.headers = {
    'access-token': `${credentials ? credentials.token : ''}`,
    uid: `${credentials ? credentials.uid : ''}`,
    client: `${credentials ? credentials.client : ''}`,
  };
  return configuration;
}, error => Promise.reject(error));

instance.interceptors.response.use(response => (response),
  (error) => {
    if (error.response && error.response.status === 401) {
      clear();
      history.push('/login');
    }

    const err = error.response ? error.response.data : { error: error.message };
    return Promise.reject(err);
  },
);

export default instance;



// WEBPACK FOOTER //
// ./src/utils/axios.js